var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import 'isomorphic-fetch';
import 'jquery';
import 'reflect-metadata';
import { PLATFORM } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import { TokenClient } from './app/services/authentication/token-client.service';
import { RequestConstants } from './app/configuration/request.constants';
import { ConfigurationService } from './app/services/basics/configuration.service';
import { UserClaimsService } from './app/services/authentication/user-claims.service';
import HttpBackend from 'i18next-http-backend';
import { TValueConverter } from 'aurelia-i18n';
import moment from 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { BrandingType, TemplateType } from './app/services/modules/brand-client.service';
import { ConfigClientService } from './app/services/modules/client-config.service';
import { RequestClient } from './app/services/basics/request-client.service';
import * as Enumerable from 'linq';
import { tagText } from './app/utilities/inline-text-marker';
window.dataLayer = window.dataLayer || [];
export function getMainWindow(tokenService) {
    if (tokenService.isAdmin() && !tokenService.isPreview) {
        // if it is admin module
        return 'app/views/app/admin/admin';
    }
    else if (tokenService.isOverlay) {
        // if its form editor of from client
        // if is showing overlay
        return 'app/views/app/client-overlay/client-overlay';
    }
    else if (tokenService.isClient() || tokenService.isPreview) {
        return 'app/views/app/client/client';
    }
    // else return anonymous
    return 'app/views/app/anonymous/anonymous';
}
export function configureInternal(aurelia, requireDev) {
    return __awaiter(this, void 0, void 0, function () {
        var global, server, configurationService, userClaimsService, tokenService, requestClient, configClientService, main, rootMap, lang, resources, fallbackLang, fb;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("app started");
                    global = window;
                    server = global.server;
                    // console.error("server " + JSON.stringify(server));
                    global.lang = server.user.languageCode;
                    aurelia.use.standardConfiguration();
                    console.log('IS_DEV_BUILD: ', server.isDevelopment);
                    if (server.isDevelopment) {
                        aurelia.use.developmentLogging();
                    }
                    new HttpClient().configure(function (config) {
                        var baseUrl = "/";
                        config.withBaseUrl(baseUrl);
                    });
                    configurationService = aurelia.container.get(ConfigurationService);
                    userClaimsService = aurelia.container.get(UserClaimsService);
                    tokenService = aurelia.container.get(TokenClient);
                    requestClient = aurelia.container.get(RequestClient);
                    configClientService = aurelia.container.get(ConfigClientService);
                    tokenService.langs = ['en', 'it', 'pl', 'zh-CN', 'pt', 'da', 'ru'];
                    tokenService.lang = global.lang;
                    tokenService.gameId = server.gameId;
                    tokenService.currentlyLockedByUser = server.currentlyLockedByUser;
                    tokenService.currencies = server.currencies;
                    tokenService.versionNumber = server.version;
                    tokenService.lotteries = server.lotteries;
                    tokenService.isPreview = server.isPreview;
                    tokenService.isOverlay = server.isOverlay;
                    tokenService.referer = server.referer;
                    tokenService.kycWinningAmountThreshold = server.kycWinningAmountThreshold;
                    tokenService.setUser(server.user);
                    tokenService.supportUri = server.supportUrl;
                    tokenService.setStorageUri(server.azureStorageUri);
                    tokenService.setIsDevelopment(server.isDevelopment, server.hostname);
                    requestClient.enableLoginDialog = server.user.enableLoginDialog;
                    userClaimsService.setUserClaims(server.user.claims);
                    requestClient.isAdmin = tokenService.isAdmin();
                    requestClient.isPreview = tokenService.isPreview;
                    main = getMainWindow(tokenService);
                    rootMap = {
                        'app/views/app/anonymous/anonymous': PLATFORM.moduleName('app/views/app/anonymous/anonymous'),
                        'app/views/app/client/client': PLATFORM.moduleName('app/views/app/client/client'),
                        'app/views/app/admin/admin': PLATFORM.moduleName('app/views/app/admin/admin'),
                        'app/views/app/client-overlay/client-overlay': PLATFORM.moduleName('app/views/app/client-overlay/client-overlay'),
                    };
                    if (server && server.xsrfToken) {
                        configurationService.add({
                            key: 'X-XSRF-TOKEN',
                            value: server.xsrfToken,
                            type: RequestConstants.ConfigurationTypes.RequestHeaders
                        });
                    }
                    lang = tokenService.lang;
                    return [4 /*yield*/, requireLocale(lang, tokenService, configClientService)];
                case 1:
                    resources = _a.sent();
                    fallbackLang = "en";
                    if (!(lang !== fallbackLang)) return [3 /*break*/, 3];
                    return [4 /*yield*/, requireLocale(fallbackLang, tokenService, configClientService)];
                case 2:
                    fb = _a.sent();
                    resources[fallbackLang] = fb[fallbackLang];
                    _a.label = 3;
                case 3:
                    // if (lang != fallbackLang) // if not english require english as well as a fallback
                    // {
                    //     resources[fallbackLang] = await requireLocale(fallbackLang, tokenService, configClientService)[fallbackLang];
                    // }
                    if (requireDev)
                        requireDev(tokenService);
                    aurelia.use
                        .globalResources(PLATFORM.moduleName('app/utilities/async-binding'))
                        .globalResources(PLATFORM.moduleName('app/utilities/dirty-binding'))
                        .globalResources(PLATFORM.moduleName('app/utilities/async-dirty-binding'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/analytics-setter/analytics-setter'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/innerhtml-read-more-less.attribute'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/lookups/lookup-property.attribute'))
                        .globalResources(PLATFORM.moduleName('app/views/components/converters/from-assets'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/validations/validation-property.attribute'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/async-click-with-loading/async-click-with-loading'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/animatable-if/animatable-if'))
                        .globalResources(PLATFORM.moduleName('app/converters/ticket-sales-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/numeral-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/currency-jackpot-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/lottery-result-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/number-format'))
                        .globalResources(PLATFORM.moduleName('app/converters/remaining-time-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/replace-dash-and-capitalize'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/configurable'))
                        .plugin(PLATFORM.moduleName('oribella-aurelia-sortable'))
                        .plugin(PLATFORM.moduleName('aurelia-ui-virtualization'))
                        .plugin(PLATFORM.moduleName('aurelia-validation'))
                        .plugin(PLATFORM.moduleName('aurelia-i18n'), function (instance) {
                        // register backend plugin
                        instance.i18next.use(HttpBackend);
                        if (isInlineTextEditMode()) {
                            var looksLikeAsset_1 = function (v) {
                                return /^(https?:|\/\/|\/|data:|blob:)/i.test(v) || /\.(png|jpe?g|gif|svg|webp|avif|ico|mp4|webm)(\?.*)?$/i.test(v);
                            };
                            var looksLikeI18nKey_1 = function (v) { return /^[a-z0-9]+(?:-[a-z0-9]+)+$/.test(v); };
                            var proto = TValueConverter.prototype;
                            var originalToView_1 = proto.toView;
                            proto.toView = function (value, options) {
                                var result = originalToView_1.call(this, value, options);
                                if (typeof value === "string" && typeof result === "string"
                                    && this.service && this.service.i18next && !looksLikeAsset_1(result)
                                    && (this.service.i18next.exists(value, options)
                                        || (result === value && looksLikeI18nKey_1(value))))
                                    return tagText(window, value, result);
                                return result;
                            };
                        }
                        // adapt options to your needs (see http://i18next.com/docs/options/)
                        // make sure to return the promise of the setup method, in order to guarantee proper loading
                        return instance.setup({
                            // backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },  //Add for network loading
                            resources: resources,
                            lng: global.lang,
                            attributes: ['t', 'i18n', 'translate'],
                            fallbackLng: fallbackLang,
                            debug: false
                        });
                    });
                    global.lookups = server.lookups;
                    moment.locale(global.lang);
                    aurelia.start().then(function () {
                        console.log("app loaded " + new Date());
                        console.log("Main:" + main);
                        // return aurelia.setRoot(main);
                        var root = rootMap[main];
                        if (!root) {
                            console.error('Unknown root module:', main);
                            // fallback if you like:
                            return aurelia.setRoot(PLATFORM.moduleName('app/views/app/anonymous/anonymous'));
                        }
                        return aurelia.setRoot(root);
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function configure(aurelia) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configureInternal(aurelia, null)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
// The preview iframe passes ?editText=true when the render editor's inline text-edit toggle is on.
export function isInlineTextEditMode() {
    try {
        return new URLSearchParams(window.location.search).get("editText") === "true";
    }
    catch (_a) {
        return false;
    }
}
export function addPrefix(key, object) {
    var newObject = {};
    for (var innerKey in object) {
        newObject["".concat(key, "-").concat(innerKey)] = object[innerKey];
    }
    return newObject;
}
export function requireText(lang, resources, tokenService, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var locales, isClient, lotteryPlatformLocale, _a, jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonOverlay, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, result, result_1, result_1_1, item, key, items, items_1, items_1_1, listItem, listItemKey, defaultItem, _b, renderText, genesisLocal, lotteryPlatformLocal;
        var e_1, _c, e_2, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    locales = [];
                    isClient = tokenService.isClient();
                    if (!(isClient || tokenService.isPreview || tokenService.isOverlay)) return [3 /*break*/, 9];
                    lotteryPlatformLocale = {};
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, configClientService.requireJSONRequest(require("locale/igaming-lottery/".concat(lang, ".json")), true)];
                case 2:
                    lotteryPlatformLocale = _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _e.sent();
                    console.log("Did not find igaming-lottery ".concat(lang, ".json"));
                    return [3 /*break*/, 4];
                case 4:
                    // load text
                    locales = [lotteryPlatformLocale];
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    jsonResults = configClientService.getClientConfig(TemplateType.Results);
                    jsonPurchases = configClientService.getClientConfig(TemplateType.Purchases);
                    jsonCart = configClientService.getClientConfig(TemplateType.Cart);
                    jsonOverlay = configClientService.getClientConfig(TemplateType.Overlay);
                    jsonLobby = configClientService.getClientConfig(TemplateType.Lobby);
                    jsonLottery = configClientService.getClientConfig(TemplateType.Lottery);
                    jsonInstantGame = configClientService.getClientConfig(TemplateType.InstantGame);
                    jsonBundle = configClientService.getClientConfig(TemplateType.Bundle);
                    jsonSyndicate = configClientService.getClientConfig(TemplateType.Syndicate);
                    return [4 /*yield*/, Promise.all([jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, jsonOverlay])];
                case 6:
                    result = _e.sent();
                    try {
                        // load locale
                        for (result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                            item = result_1_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                try {
                                    if (Array.isArray(item[key])) { // if is array
                                        items = item[key];
                                        try {
                                            for (items_1 = (e_2 = void 0, __values(items)), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                                                listItem = items_1_1.value;
                                                listItemKey = listItem["key"];
                                                if (key == TemplateType.Ads) // if is ads key add prefix
                                                    locales.push(addPrefix("".concat(listItemKey, "-link"), listItem[BrandingType.Text][lang]));
                                                else // else its the root key
                                                 {
                                                    defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                    locales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Text][lang] : {}));
                                                    // overwrite with current values
                                                    locales.push(addPrefix(listItemKey, listItem[BrandingType.Text][lang]));
                                                }
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (items_1_1 && !items_1_1.done && (_d = items_1.return)) _d.call(items_1);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                    }
                                    else { // if is object
                                        if (key == TemplateType.Ads) // if is ads key add prefix
                                            locales.push(addPrefix("link", item[key][BrandingType.Text][lang]));
                                        else // else its the root key
                                            locales.push(item[key][BrandingType.Text][lang]);
                                    }
                                }
                                catch ( /* skip a malformed/missing blob asset key */_f) { /* skip a malformed/missing blob asset key */ }
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (result_1_1 && !result_1_1.done && (_c = result_1.return)) _c.call(result_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [3 /*break*/, 8];
                case 7:
                    _b = _e.sent();
                    console.log('Blob text config unavailable; using DB overlay only');
                    return [3 /*break*/, 8];
                case 8:
                    renderText = window.server && window.server.renderTextImage && window.server.renderTextImage.text;
                    if (renderText && renderText[lang])
                        locales.push(renderText[lang]);
                    return [3 /*break*/, 10];
                case 9:
                    genesisLocal = require("locale/genesis/".concat(lang, ".json"));
                    lotteryPlatformLocal = require("locale/igaming-lottery/".concat(lang, ".json"));
                    locales = [
                        genesisLocal,
                        lotteryPlatformLocal
                    ];
                    _e.label = 10;
                case 10:
                    // load locales into app
                    locales.filter(function (x) { return JSON.stringify(x) != '{}' && x != undefined; }).forEach(function (locale) {
                        var keys = Object.keys(locale);
                        keys.forEach(function (key) {
                            resources[lang]['translation'][key] = locale[key];
                        });
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function requireImages(lang, resources, tokenClient, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var imageLocales, isClient, jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonOverlay, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, result, jsonConfig, ticketImage, assets, assetColors, lobby, result_2, result_2_1, item, key, items, items_2, items_2_1, listItem, listItemKey, defaultItem, _a, renderImage;
        var e_3, _b, e_4, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    imageLocales = [];
                    isClient = tokenClient.isClient();
                    if (!(isClient || tokenClient.isPreview || tokenClient.isOverlay)) return [3 /*break*/, 6];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    jsonResults = configClientService.getClientConfig(TemplateType.Results);
                    jsonPurchases = configClientService.getClientConfig(TemplateType.Purchases);
                    jsonCart = configClientService.getClientConfig(TemplateType.Cart);
                    jsonOverlay = configClientService.getClientConfig(TemplateType.Overlay);
                    jsonLobby = configClientService.getClientConfig(TemplateType.Lobby);
                    jsonLottery = configClientService.getClientConfig(TemplateType.Lottery);
                    jsonInstantGame = configClientService.getClientConfig(TemplateType.InstantGame);
                    jsonBundle = configClientService.getClientConfig(TemplateType.Bundle);
                    jsonSyndicate = configClientService.getClientConfig(TemplateType.Syndicate);
                    return [4 /*yield*/, Promise.all([jsonAssets, jsonLobby, jsonResults, jsonPurchases, jsonCart, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, jsonOverlay])];
                case 2:
                    result = _d.sent();
                    return [4 /*yield*/, configClientService.getClientConfig(TemplateType.Config)];
                case 3:
                    jsonConfig = _d.sent();
                    ticketImage = jsonConfig && jsonConfig[TemplateType.Config] && jsonConfig[TemplateType.Config][TemplateType.Ticket]
                        && jsonConfig[TemplateType.Config][TemplateType.Ticket][BrandingType.Images];
                    if (ticketImage && ticketImage[lang])
                        imageLocales.push(ticketImage[lang]);
                    assets = Enumerable.from(result).firstOrDefault(function (x) { return x[TemplateType.Assets]; });
                    if (assets && assets[TemplateType.Assets]) {
                        assetColors = Enumerable.from(assets[TemplateType.Assets])
                            .select(function (x) { return addPrefix(x.key, x[BrandingType.Colors]); }).toArray();
                        imageLocales = assetColors.concat(imageLocales);
                    }
                    lobby = Enumerable.from(result).firstOrDefault(function (x) { return x[TemplateType.Lobby]; });
                    if (lobby && lobby[TemplateType.Lobby] && lobby[TemplateType.Lobby][BrandingType.Featured])
                        imageLocales.push(lobby[TemplateType.Lobby][BrandingType.Featured]);
                    try {
                        // load images
                        for (result_2 = __values(result), result_2_1 = result_2.next(); !result_2_1.done; result_2_1 = result_2.next()) {
                            item = result_2_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                try {
                                    if (Array.isArray(item[key])) { // if is array
                                        items = item[key];
                                        try {
                                            for (items_2 = (e_4 = void 0, __values(items)), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
                                                listItem = items_2_1.value;
                                                listItemKey = listItem["key"];
                                                if (key == TemplateType.Ads) // if is ads key add prefix
                                                    imageLocales.push(addPrefix("".concat(listItemKey, "-image"), listItem[BrandingType.Images][lang]));
                                                else // else its the root key
                                                 {
                                                    defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                    imageLocales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Images][lang] : {}));
                                                    // overwrite with current values
                                                    imageLocales.push(addPrefix(listItemKey, listItem[BrandingType.Images][lang]));
                                                }
                                            }
                                        }
                                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                        finally {
                                            try {
                                                if (items_2_1 && !items_2_1.done && (_c = items_2.return)) _c.call(items_2);
                                            }
                                            finally { if (e_4) throw e_4.error; }
                                        }
                                    }
                                    else { // if is object
                                        if (key == TemplateType.Ads) // if is ads key add prefix
                                            imageLocales.push(addPrefix("image", item[key][BrandingType.Images][lang]));
                                        else // else its the root key
                                            imageLocales.push(item[key][BrandingType.Images][lang]);
                                    }
                                }
                                catch ( /* skip a malformed/missing blob asset key */_e) { /* skip a malformed/missing blob asset key */ }
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (result_2_1 && !result_2_1.done && (_b = result_2.return)) _b.call(result_2);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    _a = _d.sent();
                    console.log('Blob image config unavailable; using DB overlay only');
                    return [3 /*break*/, 5];
                case 5:
                    renderImage = window.server && window.server.renderTextImage && window.server.renderTextImage.image;
                    if (renderImage && renderImage[lang])
                        imageLocales.push(renderImage[lang]);
                    _d.label = 6;
                case 6:
                    // load images into app
                    imageLocales.forEach(function (locale) {
                        var keys = Object.keys(locale);
                        keys.forEach(function (key) {
                            var value = locale[key];
                            // substring to remove quotes from images
                            if (value && value.startsWith("/attachments/")) {
                                value = value.replace("/attachments/", tokenClient.storageUri + "attachments/");
                            }
                            resources[lang]['translation'][key] = value;
                        });
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function requireLocale(lang, tokenService, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var resources, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    resources = {};
                    resources[lang] = { translation: {} };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, requireImages(lang, resources, tokenService, configClientService)];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    console.log('Images Not found');
                    return [3 /*break*/, 4];
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    console.log("get text for lang: " + lang);
                    return [4 /*yield*/, requireText(lang, resources, tokenService, configClientService)];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _b = _c.sent();
                    console.log('Language not found!');
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, resources];
            }
        });
    });
}
